export default __webpack_public_path__ + "static/media/5_Intro.9337e2ca.mp4";